import React from 'react';
import ButtonsGeneric from '../ButtonsGeneric';
import InputText from '../InputText';
import SelectAndOptions from '../SelectAndOptions';
import { TableCalcStyle, WrapperTables } from '../TableCalcCompStyle';

export default function TableCalcCompRecFatEmi() {
  return (
    <WrapperTables>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>ID</th>
            <th>Evento</th>
            <th>Data Prevista faturamento</th>
            <th>Data Prevista vencimento</th>
            <th>Valor líquido</th>
            <th>Valor bruto</th>
            <th>Tipo parcela</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              <InputText title="" id="Evento1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="DataPrevistaFaturamento1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="DataPrevistaVencimento1" widthPercentage="95%" />
            </td>
            <td>
              <InputText title="" id="ValorLiquido1" widthPercentage="95%" />
            </td>
            <td>
              <p>R$ 0,00</p>
            </td>
            <td>
              <SelectAndOptions title="" id="TipoParcela1" optionsArray={['', 'fixa']} widthPercentage="95%" />
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
      <ButtonsGeneric>
        <button className="success">+ Adicionar</button>
      </ButtonsGeneric>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>Total Valor líquido</th>
            <th>Total Valor bruto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>R$ 0,00</p>
            </td>
            <td>
              <p>R$ 0,00</p>
            </td>
            <td>
              <p>-----</p>
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
    </WrapperTables>
  );
}
